import { render } from "./DeliveriesModal.vue?vue&type=template&id=8848823e"
import script from "./DeliveriesModal.vue?vue&type=script&lang=js"
export * from "./DeliveriesModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__